(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-concept-video-root]');
  if (!roots.length) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function hydrate(root) {
    if (!root || root.dataset.loaded === 'true') return;

    root.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    var video = root.querySelector('[data-concept-video]');
    root.dataset.loaded = 'true';
    if (video) video.load();
  }

  function setMuted(video, muted) {
    if (!video) return;

    video.muted = muted;
    if (muted) {
      video.setAttribute('muted', '');
    } else {
      video.removeAttribute('muted');
    }
  }

  function isAudioOn(root) {
    return root.dataset.audio === 'on';
  }

  function updateAudioControl(root) {
    var audioOn = isAudioOn(root);
    var button = root.querySelector('[data-concept-video-audio]');

    if (button) {
      button.setAttribute('aria-pressed', audioOn ? 'true' : 'false');
      button.setAttribute('aria-label', audioOn ? '音声をオフにする' : '音声をオンにする');
    }
  }

  function play(root) {
    var video = root.querySelector('[data-concept-video]');
    if (!video) return;

    hydrate(root);
    if (reducedMotion.matches || document.hidden || root.dataset.inView !== 'true') return;

    setMuted(video, !isAudioOn(root));
    video.setAttribute('playsinline', '');

    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {});
    }
  }

  function pause(root) {
    var video = root.querySelector('[data-concept-video]');
    if (video && !video.paused) video.pause();
  }

  function toggleAudio(root) {
    var video = root.querySelector('[data-concept-video]');
    var audioOn = !isAudioOn(root);

    root.dataset.audio = audioOn ? 'on' : 'off';
    setMuted(video, !audioOn);
    updateAudioControl(root);
    play(root);
  }

  roots.forEach(function (root) {
    var button = root.querySelector('[data-concept-video-audio]');

    root.dataset.audio = 'off';
    root.dataset.inView = 'false';
    updateAudioControl(root);

    if (button) {
      button.addEventListener('click', function () {
        toggleAudio(root);
      });
    }
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var root = entry.target;
        root.dataset.inView = entry.isIntersecting && entry.intersectionRatio >= 0.24 ? 'true' : 'false';

        if (root.dataset.inView === 'true') {
          play(root);
        } else {
          pause(root);
        }
      });
    }, {
      root: null,
      rootMargin: '240px 0px',
      threshold: [0, 0.24, 0.7]
    });

    roots.forEach(function (root) {
      observer.observe(root);
    });
  } else {
    roots.forEach(function (root) {
      root.dataset.inView = 'true';
      play(root);
    });
  }

  document.addEventListener('visibilitychange', function () {
    roots.forEach(function (root) {
      if (document.hidden) {
        pause(root);
      } else {
        play(root);
      }
    });
  });
})();
